import { render, staticRenderFns } from "./VendorEditPage.vue?vue&type=template&id=55e59c08&"
import script from "./VendorEditPage.vue?vue&type=script&lang=js&"
export * from "./VendorEditPage.vue?vue&type=script&lang=js&"
import style0 from "./VendorEditPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports